
define('app/ko-app-touch',[
	'jquery',
	'knockout',
	'jquery.mobile-events'
], function($,ko) {
	console.log("KO_APP_TOUCH LOADED");
	
	if(window.isPhoneOrTablet){
		function datepickerSwipe(){
			$(document).off('.swipeleft swiperight', datepickerSwipeHandler)
			$(document).on('swipeleft swiperight', '.ui-datepicker', datepickerSwipeHandler);
			
			function datepickerSwipeHandler(e){
				var that = $(this);
				$(document).one('tapend', function(){
					if(e.type =='swipeleft'){
						that.find('.ui-datepicker-next').trigger('click')
					} else {
						that.find('.ui-datepicker-prev').trigger('click')
					} 
				});
			}
		}
		datepickerSwipe();
	}
	
	function bindCarouselSwipe() {
		$(document).on('swiperight', '.carousel', function() {
			$(this).carousel("pause").removeData();
			$(this).carousel('prev');
		});
		$(document).on('swipeleft', '.carousel', function() {
			$(this).carousel("pause").removeData();
			$(this).carousel('next');
		});
	}
	var carouselSwipeLoaded = false;
    $(window).on('orientationchange', function(event) {
        if (!window.isPhoneOrTablet && !carouselSwipeLoaded) {
            bindCarouselSwipe();
            carouselSwipeLoaded = true;
        }
    });
	if($(window).width() < 992)
		bindCarouselSwipe();

});
	
